import type * as Types from '../../../__generated__/bffGlobalTypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GenerateApiKeyVariables = Types.Exact<{ [key: string]: never; }>;


export type GenerateApiKey = {
  createPartnerAuthToken: string
};


export const GenerateApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateApiKey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPartnerAuthToken"}}]}}]} as unknown as DocumentNode<GenerateApiKey, GenerateApiKeyVariables>;